exports.routes = {
	en: {
		home: "/",
		privacyPolicy: "/privacy-policy",
		ccReport2020: "",
		customerCareLP: "/finance-customer-care",
		blogTag: "/blog/tag",
		blog: "/blog",
		product: "/product",
		ueFunds: "/ue-funds",
		termsConditions: "/terms-and-conditions",
		thankYou: "/thank-you",
		chatGPT: "/openai-api-calculator",
	},
	pl: {
		home: "/pl",
		privacyPolicy: "/pl/polityka-prywatnosci",
		ccReport2020: "/pl/raport2020",
		customerCareLP: "/pl/obsluga-klienta-finanse",
		blogTag: "/pl/blog/tag",
		blog: "/pl/blog",
		product: "/pl/produkt",
		ueFunds: "/pl/fundusze-ue",
		termsConditions: "/pl/zasady-i-warunki",
		thankYou: "/pl/dziekujemy",
		chatGPT: "/pl/kalkulator-api-openai",
	},
};
